import { lazy } from 'react';
import { Navigate, useParams } from 'react-router-dom';

const GeneralEnquiryConfirmation = lazy(
    () => import('../containers/General/ReferralConfirmation/Confirmation')
);
const HomeLoanReferralConfirmation = lazy(
    () => import('../containers/HomeLoan/ReferralConfirmation/Confirmation')
);
const PersonalLoanConfirmation = lazy(
    () => import('../containers/PersonalLoan/ReferralConfirmation/Confirmation')
);
const HardshipConfirmation = lazy(() => import('../containers/Hardship/ReferralConfirmation/Confirmation'));

const HOME_LOAN_ALLOWED_SUBPATHS = ['apply', 'lender-enquiry','confirmation'];

export default function ConfirmationGatekeeper() {
    const params = useParams<{ enquiryFormType?: string; '*'?: string }>();
    const enquiryFormType = params.enquiryFormType;
    const subPath = params['*']; // may be undefined
    const segments = subPath?subPath.split('/'):'';
    if (!enquiryFormType) return <Navigate to="/404" replace />;
    
    // HOME LOAN confirmations
    if (enquiryFormType === 'home-loan') {
        // /home-loan/confirmation
        if (!subPath || subPath === '') return <HomeLoanReferralConfirmation />;

        // /home-loan/apply/confirmation or /home-loan/lender-enquiry/confirmation
        if (HOME_LOAN_ALLOWED_SUBPATHS.includes(segments[0])) return <HomeLoanReferralConfirmation />;

        return <Navigate to="/404" replace />;
    }

    // Other enquiry types � must not have subpath
    if (subPath && subPath !== '' && segments.length > 0 && (segments[0] != 'confirmation' || segments[segments.length - 1] != 'confirmation')) return <Navigate to="/404" replace />;

    switch (enquiryFormType) {
        case 'general':
            return <GeneralEnquiryConfirmation />;

        case 'personal-loan':
            return <PersonalLoanConfirmation />;

        case 'hardship':
            return <HardshipConfirmation />;

        case 'financial-planning':
            return <Navigate to="/general" replace />;

        default:
            return <Navigate to="/404" replace />;
    }
}